import React from "react";
import { Link } from "react-router-dom";

function LinkToInstitutionAccount(props) {
  let text, path, linkText;

  if (props.onRegister) {
    text = "Already have an account?";
    path = "/LoginAsInstitution";
    linkText = "Sign in";
  } else {
    text = "Are you a teacher?";
    path = "/Login";
    linkText = "Login Here";
  }

  return (
    <div className="w-100 text-center mt-3">
      {text}
      &nbsp;
      <u>
        <Link to={path}>{linkText} >></Link>
      </u>
    </div>
  );
}

export default LinkToInstitutionAccount;
